import {
  ChangePasswordRequest,
  ChangePasswordResponse,
  ForgotPasswordRequest,
  ResetPasswordRequest,
  ResetPasswordResponse,
  SignInRequest,
  SignInResponse,
  SignupRequest,
  SignUpResponse
} from '@/types/users';
import { apiSlice } from './api';
import {
  SendOneTimePasswordRequest,
  SendOneTimePasswordResponse,
  VerifyOneTimePasswordRequest,
  VerifyOneTimePasswordResponse
} from '@/@types/openapi-imports';

export const authSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    signIn: builder.mutation<SignInResponse, SignInRequest>({
      query: body => ({
        url: '/api/users/signin',
        method: 'POST',
        body
      }),
      transformResponse: (data: SignInResponse) => {
        document.cookie = `accessToken=${data.accessToken}; path=/; Secure; SameSite=Strict;`;
        document.cookie = `intercomToken=${data.intercomToken}; path=/; Secure; SameSite=Strict;`;
        return data;
      }
    }),

    requestOTP: builder.mutation<SendOneTimePasswordResponse, SendOneTimePasswordRequest>({
      query: body => ({
        url: '/api/users/send-one-time-password',
        method: 'POST',
        body
      })
    }),

    verifyOTP: builder.mutation<VerifyOneTimePasswordResponse, VerifyOneTimePasswordRequest>({
      query: body => ({
        url: '/api/users/verify-one-time-password',
        method: 'POST',
        body
      })
    }),

    signUp: builder.mutation<SignUpResponse, SignupRequest>({
      query: body => ({
        url: '/api/users/signup',
        method: 'POST',
        body
      })
    }),

    forgotPassword: builder.mutation<void, ForgotPasswordRequest>({
      query: body => ({
        url: '/api/users/request-reset-password',
        method: 'POST',
        body
      })
    }),

    resetPassword: builder.mutation<ResetPasswordResponse, ResetPasswordRequest>({
      query: body => ({
        url: '/api/users/reset-password',
        method: 'POST',
        body
      })
    }),

    changePassword: builder.mutation<ChangePasswordResponse, ChangePasswordRequest>({
      query: body => ({
        url: '/api/users/change-password',
        method: 'POST',
        body
      })
    })
  })
});

export const {
  useSignInMutation,
  useRequestOTPMutation,
  useVerifyOTPMutation,
  useSignUpMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useChangePasswordMutation
} = authSlice;
